import axios from 'axios';

function createApiClient(baseURL) {
  const client = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' },
  });

  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  client.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401) {
        const detail = err.response?.data?.detail;
        const msg = typeof detail === 'string'
          ? detail
          : 'Session expired — please sign in again.';
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        if (!window.location.pathname.startsWith('/login')) {
          sessionStorage.setItem('auth_redirect_reason', msg);
          window.location.href = '/login';
        }
      }
      return Promise.reject(err);
    }
  );

  return client;
}

export default createApiClient;
